module.exports = __webpack_public_path__ + "img/channel-talk.84f2257c.png";